import { Basicprimitives } from "@common/controls/Diagram/Basicprimitives/types";
import Network from "@common/modules/network/types";
import { Common } from "@common/types";

export const formatVolumeNumber = (value: number | null | undefined): string => (value ?? 0).toFixed(2);

export type GenealogyItem = Omit<Network.Genealogy, "parentId"> & Basicprimitives.OrgItemConfig;

export type DiagramItemComponentProps<T> = {
  parameters: Common.GenericMap<any>;
  item: T;
  exit: () => void;
};

export const mapItem = (x: Network.Genealogy): GenealogyItem => ({
  ...x,
  parent: !x.parentId ? null : x.parentId.toString(),
  templateName: "genealogy",
  hasButtons: x.userId ? Basicprimitives.Enabled.True : Basicprimitives.Enabled.False,
  noHighlight: x.isDeleted,
  color: x.commissionPercentage ? x.pinRankColor : "#ddd",
  itemTitleColor: x.commissionPercentage ? x.pinRankColor : "#ddd"
});
